export default __webpack_public_path__ + "navigation-examples-route-init-v1-960-c1d354473efd2edb0d440ab5e55e41c0.webp";